export default __webpack_public_path__ + "static/media/retailStaff.b3bd708a.svg";